import React from 'react';
import styled, { keyframes } from 'styled-components';

function OnlineIndicator({ isOnline, size = '8px' }) {
  return isOnline ? (
    <Dot $size={size} title="User is currently online" />
  ) : null;
}

const pulse = keyframes`
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 5px rgba(34, 197, 94, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
  }
`;

const Dot = styled.div`
  animation: ${pulse} 2s infinite;
  background-color: #22c55e;
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.3);
  height: ${({ $size }) => $size};
  position: relative;
  width: ${({ $size }) => $size};

  /* Increase hover area while keeping visual size the same */
  &::before {
    border-radius: 50%;
    bottom: -8px;
    content: '';
    left: -8px;
    position: absolute;
    right: -8px;
    top: -8px;
    /* Invisible area that extends hover zone */
  }
`;

export default OnlineIndicator;
